import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { tField } from '../../utils/bilingualHelper';
import { translationAPI } from '../../utils/api';

const StudentAlertModal = ({ alertContext }) => {
  const { t } = useTranslation();
  const [isTranslating, setIsTranslating] = useState(false);

  if (!alertContext || !alertContext.isAlertOpen) return null;

  const {
    alertStudent,
    alertMessage,
    setAlertMessage,
    alertTargets,
    toggleTarget,
    sendingAlert,
    closeAlert,
    sendAlert,
    toast,
    alertMessageZh,
    setAlertMessageZh
  } = alertContext;

  const handleTranslate = async () => {
    if (!alertMessage?.trim()) return;
    setIsTranslating(true);
    try {
      const res = await translationAPI.translate(alertMessage.trim());
      if (res?.responseData?.translatedText) {
        setAlertMessageZh(res.responseData.translatedText);
      }
    } catch (err) {
      console.error('Translation failed', err);
    } finally {
      setIsTranslating(false);
    }
  };

  return (
    <>
      <div 
        style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          backdropFilter: 'blur(4px)',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          animation: 'fadeIn 0.2s ease'
        }}
        onClick={closeAlert}
      >
        <div 
          style={{
            background: '#fff',
            borderRadius: 16,
            width: '90%',
            maxWidth: 500,
            padding: 24,
            boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
            animation: 'slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <div>
              <h2 style={{ fontSize: 20, color: 'var(--wine)', margin: 0, fontWeight: 700 }}>{t('studentAlert.title')}</h2>
              <div style={{ fontSize: 13, color: '#7a7068', marginTop: 4 }}>{t('studentAlert.target')} <strong>{tField(alertStudent.name) || tField(alertStudent.studentName)}</strong>
              </div>
            </div>
            <button 
              onClick={closeAlert}
              style={{
                background: '#f5f5f5', border: 'none', borderRadius: '50%',
                width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', fontSize: 16, color: '#555'
              }}
            >
              ×
            </button>
          </div>

          <form onSubmit={sendAlert} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {/* Checkboxes Target Select */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: '#3d3730', textTransform: 'uppercase' }}>{t('studentAlert.recipientChannels')}</label>
              <div style={{ display: 'flex', gap: 10 }}>
                <button
                  type="button"
                  onClick={() => toggleTarget('student')}
                  style={{
                    flex: 1, padding: '10px 12px', borderRadius: 8,
                    border: `1.5px solid ${alertTargets.includes('student') ? 'var(--wine)' : '#e0d8ce'}`,
                    background: alertTargets.includes('student') ? '#fff4f7' : '#fff',
                    color: alertTargets.includes('student') ? 'var(--wine)' : '#3d3730',
                    fontWeight: 600, fontSize: 12, cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                    transition: 'all 0.2s ease'
                  }}>
                  <input 
                    type="checkbox" 
                    checked={alertTargets.includes('student')} 
                    readOnly 
                    style={{ pointerEvents: 'none' }}
                  />{t('studentAlert.studentInbox')}</button>
                <button
                  type="button"
                  onClick={() => toggleTarget('parent')}
                  style={{
                    flex: 1, padding: '10px 12px', borderRadius: 8,
                    border: `1.5px solid ${alertTargets.includes('parent') ? 'var(--wine)' : '#e0d8ce'}`,
                    background: alertTargets.includes('parent') ? '#fff4f7' : '#fff',
                    color: alertTargets.includes('parent') ? 'var(--wine)' : '#3d3730',
                    fontWeight: 600, fontSize: 12, cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                    transition: 'all 0.2s ease'
                  }}>
                  <input 
                    type="checkbox" 
                    checked={alertTargets.includes('parent')} 
                    readOnly 
                    style={{ pointerEvents: 'none' }}
                  />{t('studentAlert.parentInbox')}</button>
              </div>
            </div>

            {/* Custom Alert Message (English) */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <label style={{ fontSize: 11, fontWeight: 700, color: '#3d3730', textTransform: 'uppercase' }}>
                  Broadcast Message (English)
                </label>
                <button
                  type="button"
                  onClick={handleTranslate}
                  disabled={isTranslating}
                  style={{
                    background: 'none', border: 'none', color: 'var(--wine)',
                    fontSize: 12, fontWeight: 600, cursor: 'pointer',
                    display: 'flex', alignItems: 'center', gap: 4, opacity: isTranslating ? 0.5 : 1
                  }}
                >
                  {isTranslating ? 'Translating...' : (
                    <>
                      <span style={{ fontSize: 14 }}>🌐</span> Auto-Translate
                    </>
                  )}
                </button>
              </div>
              <textarea
                value={alertMessage}
                onChange={e => setAlertMessage(e.target.value)}
                required
                placeholder="English message..."
                style={{
                  width: '100%', minHeight: '100px', padding: '12px',
                  borderRadius: 12, border: '1px solid #e0d8ce', fontSize: 13,
                  lineHeight: 1.5, resize: 'vertical', background: '#fcfbf9',
                  color: '#3d3730', outline: 'none', transition: 'border-color 0.2s'
                }}
                onFocus={(e) => e.target.style.borderColor = 'var(--wine)'}
                onBlur={(e) => e.target.style.borderColor = '#e0d8ce'}
              />
            </div>

            {/* Custom Alert Message (Chinese) */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: '#3d3730', textTransform: 'uppercase' }}>
                Broadcast Message (Chinese)
              </label>
              <textarea
                value={alertMessageZh}
                onChange={e => setAlertMessageZh(e.target.value)}
                required
                placeholder="Chinese message..."
                style={{
                  width: '100%', minHeight: '100px', padding: '12px',
                  borderRadius: 12, border: '1px solid #e0d8ce', fontSize: 13,
                  lineHeight: 1.5, resize: 'vertical', background: '#fcfbf9',
                  color: '#3d3730', outline: 'none', transition: 'border-color 0.2s'
                }}
                onFocus={(e) => e.target.style.borderColor = 'var(--wine)'}
                onBlur={(e) => e.target.style.borderColor = '#e0d8ce'}
              />
            </div>

            {/* Actions */}
            <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
              <button
                type="button"
                onClick={closeAlert}
                className="btn btn-outline"
                style={{ flex: 1, padding: '12px' }}>
                Cancel
              </button>
              <button
                type="submit"
                disabled={sendingAlert || !alertMessage?.trim() || !alertMessageZh?.trim() || isTranslating}
                className="btn btn-primary"
                style={{ flex: 1.5, padding: '12px', background: 'var(--wine)', borderColor: 'var(--wine)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, opacity: sendingAlert ? 0.7 : 1 }}>
                <span>{sendingAlert ? 'Dispatching...' : 'Dispatch Alert'}</span>
                <span>➔</span>
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* 🚀 Toast Notifications */}
      {toast && (
        <div style={{
          position: 'fixed', bottom: 24, right: 24,
          background: toast.type === 'error' ? '#c0392b' : '#2d7a52',
          color: '#fff', padding: '16px 28px', borderRadius: 12,
          boxShadow: '0 10px 25px rgba(0,0,0,0.2)', zIndex: 1100,
          fontWeight: 600, display: 'flex', alignItems: 'center', gap: 10,
          animation: 'fadeIn 0.2s ease'
        }}>
          <span>{toast.type === 'error' ? '⚠️' : '✅'}</span>
          <span>{toast.message}</span>
        </div>
      )}
    </>
  );
};

export default StudentAlertModal;
